import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <TopicsSection />
        <ContactSection />
        <RankingSection />
        <FAQSection />
        <AboutSection />
        <CardsSection />
        <FeaturesSection />
        <MediaSection />
        <UpdatesSection />
        <CarouselSection />
        <IndexSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}